import { createApp } from 'vue/dist/vue.esm-bundler.js';
import { createPinia } from 'pinia';
import SearchIndex from '../components/SearchIndex.vue';
import VideoLibraryAdvancedSearch from '../components/VideoLibraryAdvancedSearch.vue';

const initSearchApps = () => {
    const pinia = createPinia();
    const searchResultsTarget = document.querySelector('#search-results');
    const videoLibraryAdvancedSearchTarget = document.querySelector('#video-library-advanced-search');

    if (searchResultsTarget && !searchResultsTarget.dataset.vueInitialized) {
        searchResultsTarget.dataset.vueInitialized = 'true';

        createApp(SearchIndex)
            .use(pinia)
            .mount(searchResultsTarget);
    }

    if (videoLibraryAdvancedSearchTarget && !videoLibraryAdvancedSearchTarget.dataset.vueInitialized) {
        videoLibraryAdvancedSearchTarget.dataset.vueInitialized = 'true';

        createApp(VideoLibraryAdvancedSearch)
            .use(pinia)
            .mount(videoLibraryAdvancedSearchTarget);
    }
};

document.addEventListener('afterBlitzInjectAll', initSearchApps);

const main = document.querySelector('main');

if (main?.dataset.hasBlitz === 'no-blitz') {
    initSearchApps();
}
